import React from 'react';
import {Link} from "@reach/router";
import {formatCurrency} from "js/services/Format";

const SoldOutPage = ({item}) => {
  return (
    <div className="sold-out-container">
      <h1>Sorry, the item got sold out</h1>

      <div className="item-info d-flex justify-content-between align-items-center">
        <div className="item-data d-flex">
          <div className="photo">
            <img src="/images/item-default.png" alt={item.name} />
          </div>
          <div className="name">
            <strong>{item.title}</strong>
            <p>{formatCurrency(item.price)}</p>
          </div>
        </div>
        <div className="stock">
          <span>Out of stock</span>
        </div>
      </div>

      <p className="offer-description">
        But you create an offer of the same product using PayOnDelivery
      </p>

      <Link to={'/buyer-signup'} className="btn btn-pod btn-primary">
        Create an offer
      </Link>
    </div>
  );
};

export default SoldOutPage;
